import React, { Component } from 'react'

export default class LabelError extends Component {
  render() {
    const { error, forceError, errorDisabled, name, value } = this.props

    return (
      <div className="w-full flex justify-start">
        {(error || forceError) && !errorDisabled && (
          <label htmlFor={name} className="text-red-500 font-bold text-xs ml-2 mt-1">
            { error === 'required' ? '* Campo obbligatorio' : '* Dato errato o non compilato correttamente' }
          </label>
        )}
      </div>
    )
  }
}
